// This file was auto-generated by Fern from our API Definition.
export var WorkflowRevisionResponse;
(function (WorkflowRevisionResponse) {
    WorkflowRevisionResponse.Status = {
        Committed: "committed",
        NoChange: "no_change",
    };
})(WorkflowRevisionResponse || (WorkflowRevisionResponse = {}));
